import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";



import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";



gsap.registerPlugin(ScrollTrigger, ScrambleTextPlugin, SplitText);
export default () =>{
    const indication = document.querySelector('#indication')
    const stickyIndication = document.querySelector('#indication-short')
    const gotoIndication = document.querySelectorAll('.go-indication')
    const top = indication.getBoundingClientRect()
   
    const tl = gsap.timeline({
       scrollTrigger:{
           trigger: indication,
           toggleActions:"restart pause resume reverse",
           toggleClass: { targets: stickyIndication, className: 'hide-me' },

       }
   })

   if(!indication) return

   tl.to(stickyIndication,{
       duration: .5,
   })
   gotoIndication.forEach(item=>{
    item.addEventListener('click',(e)=>{
        e.stopPropagation()
        e.preventDefault()
        window.scrollTo({ top: top.top+(isMobile()?25:0), behavior: 'smooth' })

   })
   })
   
   


    


}